<template>
  <div @click="homeClick(`${parentLabel} Buttons: ${cardLabel}`)">
    <component
      :is="comingSoon ? 'span' : 'router-link'"
      :to="route"
    >
      <div
        class="home-border-card"
        :class="{ 'coming-soon': comingSoon }"
        :style="`background: ${borderColor};`"
        @mouseenter="hovered = true"
        @mouseleave="hovered = false"
      >
        <div class="home-card">
          <h5
            class="mb-2 card-label d-flex align-center"
            :style="`color: ${cardLabelColor};`"
          >
            {{ cardLabel }}
            <StatusBadge :is-new="isNew" />
          </h5>
          <p
            v-if="comingSoon"
            class="coming-soon-description"
          >
            COMING SOON
          </p>
          <p
            v-else
            class="card-description"
          >
            {{ description }}
          </p>
        </div>
      </div>
    </component>
  </div>
</template>

<script>
import { mapActions } from 'pinia';
import { useTracking } from '@/stores/tracking/tracking';
import { useColors } from '@/composables/colors';
import StatusBadge from '@/components/shared/StatusBadge.vue';

export default {
  name: 'HomeTabCard',
  components: {
    StatusBadge,
  },
  props: {
    parentLabel: { type: String, default: '' },
    cardLabel: { type: String, default: '' },
    description: { type: String, default: '' },
    primaryColor: { type: String, default: '' },
    secondaryColor: { type: String, default: '' },
    route: { type: Object, default: () => {} },
    comingSoon: { type: Boolean, default: false },
    isNew: { type: Boolean, default: false },
  },
  setup() {
    const { grey400, textDarkest: themeSecondaryColor } = useColors();

    return { grey400, themeSecondaryColor };
  },
  data() {
    return {
      hovered: false,
    };
  },
  computed: {
    borderColor() {
      if (this.comingSoon) return this.grey400;

      if (this.hovered) return `linear-gradient(to bottom, ${this.primaryColor}, ${this.secondaryColor})`;

      return this.themeSecondaryColor;
    },
    cardLabelColor() {
      if (this.hovered && !this.comingSoon) return this.primaryColor;

      return this.themeSecondaryColor;
    },
  },
  methods: {
    ...mapActions(useTracking, ['homeHover', 'homeClick']),
  },
};
</script>

<style lang="less" scoped>
.home-border-card {
  border-radius: 8px;
  width: 248px;
  height: 123px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: height 500ms ease;

  &.coming-soon {
    cursor: default;
  }
}

.home-card {
  border-radius: 7px;
  background: @white;
  width: 246px;
  height: 121px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 24px 10px;
  overflow: hidden;
  transition: height 500ms ease;
  text-align: center;
}

.coming-soon .home-card {
  background: @bg-canvas;
  justify-content: space-between;
}

.card-description {
  max-width: 172px;
  font-size: 14px !important;
  line-height: 16px !important;
  font-weight: 300;
  opacity: 0.6;
  color: @text-darkest;
}

.coming-soon-description {
  font-size: 12px !important;
  font-weight: 400;
  color: @basic-orange;
}

:deep(.badge) {
  margin-top: -15px;
}
</style>
